module.exports = __webpack_public_path__ + "img/logo.f8c39a48.svg";